import * as tslib_1 from "tslib";
import { getCurrentSubcategory } from 'owa-options-store';
import { logUsage } from 'owa-analytics';
var SAVE_DATAPOINT_NAME = 'OptionOnSave';
var DISCARD_DATAPOINT_NAME = 'OptionOnDiscard';
export default function saveOrDiscardOptions(isSave) {
    var _this = this;
    return Promise.all(getCurrentSubcategory().options.map(function (option) {
        return (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var settings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        settings = option.fullOptionFormSettings;
                        if (!settings.isDirty()) return [3 /*break*/, 3];
                        logUsage(isSave ? SAVE_DATAPOINT_NAME : DISCARD_DATAPOINT_NAME, [option.key]);
                        if (!isSave) return [3 /*break*/, 2];
                        return [4 /*yield*/, settings.onSave()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // We want to "discard" after saving as well, to clean up the view state so it's not stale
                        // if the option is changed outside the full options pane.
                        settings.onDiscard();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }));
}
//# sourceMappingURL=saveOrDiscardOptions.js.map